import { clearSaleTheme } from "./styles/theme/clearSaleTheme";
import { bradescoTheme } from "./styles/theme/bradescoTheme";
import { defaultTheme } from "./styles/theme/defaultTheme";
import { ThemeProvider } from "styled-components";
import { GlobalStyle } from "./styles/global";
import { Provider } from "react-redux";
import { Router } from "./Router";
import store from "./store";

export function App() {
  return (
    <Provider store={store}>
      <ThemeProvider
        theme={
          process.env.REACT_APP_BRADESCO_ID === "true"
            ? bradescoTheme
            : process.env.REACT_APP_CLEARSALE === "true"
            ? clearSaleTheme
            : defaultTheme
        }
      >
        <GlobalStyle />
        <Router />
      </ThemeProvider>
    </Provider>
  );
}
